<form [formGroup]="form" (ngSubmit)="save()">
  <div class="form__group" [ngClass]="{'form__error': isSubmitted() && f[field.key].errors}">
    <div class="p-float-label">
      <p-inputNumber
        [formControlName]="field.key"
        [prefix]="country.currency"
        [locale]="country.locale"
        [minFractionDigits]="2"
        [maxFractionDigits]="2"
        [min]="0"
        mode="decimal"
        (onBlur)="save()"
        class="w-full">
      </p-inputNumber>
      <label>{{ field.label }} *</label>
    </div>

    <span class="form__msgError" *ngIf="isSubmitted() && f[field.key].errors">
      <small class="p-error" *ngIf="f[field.key].hasError('required')">Requerido</small>
    </span>
  </div>
</form>
